import React, { Component, Fragment } from "reactn";
import Dialog from "@material-ui/core/es/Dialog/Dialog";
import DialogTitle from "@material-ui/core/es/DialogTitle/DialogTitle";
import DialogActions from "@material-ui/core/es/DialogActions/DialogActions";
import TextField from "@material-ui/core/es/TextField/TextField";
import { Button } from "@material-ui/core";
import { BlueOutlinedButton, BlueButton } from "js/react/components/UiComponents.js";
import { renderReactDialog, renderReactDialogFromJSX } from "js/react/renderReactRoot";
import { rand } from "js/core/utilities/utilities";
import DropDown from "js/react/components/DropDown";
import uuid from "uuid/v4";
import Checkbox from "@material-ui/core/Checkbox";
import { ScaryButton } from "js/react/components/UiComponents";

export class DialogContent extends Component {
    render() {
        let props = { ...this.props };
        if (props.className) {
            props.className += " dialog-content";
        } else {
            props.className = "dialog-content";
        }
        return <div {...props}>{this.props.children}</div>;
    }
}

export class DialogIcon extends Component {
    render() {
        return (
            <div className="dialog-icon">
                <i className="micon">{this.props.icon}</i>
            </div>
        );
    }
}

export class BeautifulDialog extends Component {
    render() {
        let dialogProps = { ...this.props };
        delete dialogProps.closeDialog; // react throws a warning if we pass the closeDialog prop through <Dialog>
        delete dialogProps.preventClose;

        return (
            <Dialog
                classes={{ paperScrollPaper: "dialog-paper" }}
                className="beautiful-dialog"
                fullWidth
                maxWidth="sm"
                disableEnforceFocus={true}
                onEscapeKeyDown={event => {
                    event.stopPropagation();
                    if (this.props.preventClose) return;
                    this.props.closeDialog && this.props.closeDialog();
                }}
                onBackdropClick={() => {
                    if (this.props.preventClose) return;
                    this.props.closeDialog && this.props.closeDialog();
                }}
                {...dialogProps}
                open
                hideBackdrop={this.props.hideBackdrop}
                disableBackdropClick={this.props.hideBackdrop}
                disableEscapeKeyDown={this.props.hideBackdrop}
            >
                {this.props.children}
            </Dialog>
        );
    }
}

export function ShowDialog(dialog, props = {}) {
    renderReactDialog(dialog, props);
}

export function ShowInputDialog(options) {
    return new Promise(resolve => {
        let inputText;
        let dialog = (
            <BeautifulDialog closeDialog={() => unmount()}
                onBackdropClick={options.onBackdropClick ? options.onBackdropClick : () => {
                }}>
                <DialogTitle>{options.title}</DialogTitle>
                <DialogContent>
                    <TextField label={options.label}
                        id="dialog-input"
                        fullWidth
                        autoFocus
                        onChange={event => {
                            inputText = event.target.value;
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            unmount();
                            resolve(null);
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            unmount();
                            resolve(inputText);
                            options.onClick && options.onClick();
                        }}
                    >
                        Ok
                    </Button>
                </DialogActions>
            </BeautifulDialog>
        );

        let unmount = renderReactDialogFromJSX(dialog);
    });
}

export function ShowMessageDialog(options) {
    const { buttonOptions = {} } = options;
    return new Promise(resolve => {
        let dialog = (
            <BeautifulDialog closeDialog={() => {
                if (options.acceptOnClose) {
                    options.onClick && options.onClick();
                }
                unmount();
            }}
            onBackdropClick={options.onBackdropClick ? options.onBackdropClick : () => {
            }}>
                <DialogTitle>{options.title}</DialogTitle>
                <DialogContent>{options.message}</DialogContent>
                <DialogActions>
                    {buttonOptions.color === "blue" ? (
                        <BlueButton
                            onClick={() => {
                                unmount();
                                resolve();
                                options.onClick && options.onClick();
                            }}
                        >
                            {options.buttonText || "OK"}
                        </BlueButton>
                    ) : (
                        <Button
                            onClick={() => {
                                unmount();
                                resolve();
                                options.onClick && options.onClick();
                            }}
                        >
                            {options.buttonText || "OK"}
                        </Button>
                    )}
                </DialogActions>
            </BeautifulDialog>
        );

        let unmount = renderReactDialogFromJSX(dialog);
    });
}

export function ShowConfirmationDialog(options) {
    let classes = null;
    if (options.warning) {
        classes = { paper: "error-dialog" };
    }

    const { buttonOptions = {} } = options;

    return new Promise((resolve, reject) => {
        let dialog = (
            <BeautifulDialog
                classes={classes}
                closeDialog={() => {
                    unmount();
                    resolve(false);
                }}
            >
                <DialogTitle>{options.title}</DialogTitle>
                <DialogContent>{options.message}</DialogContent>
                <DialogActions>
                    {buttonOptions.cancelButtonVariant === "outlined" ? (
                        <BlueOutlinedButton
                            onClick={() => {
                                options.cancelCallback && options.cancelCallback();
                                unmount();
                                resolve(false);
                            }}
                        >
                            {options.cancelButtonLabel || "Cancel"}
                        </BlueOutlinedButton>
                    ) : (
                        <Button
                            className="dialog-cancel-button"
                            onClick={() => {
                                options.cancelCallback && options.cancelCallback();
                                unmount();
                                resolve(false);
                            }}
                        >
                            {options.cancelButtonLabel || "Cancel"}
                        </Button>
                    )}
                    {
                        buttonOptions.acceptButtonColor === "red" ? (
                            <ScaryButton
                                onClick={() => {
                                    options.acceptCallback && options.acceptCallback();
                                    unmount();
                                    resolve(true);
                                }}
                            >
                                {options.okButtonLabel || "Ok"}
                            </ScaryButton>
                        ) : (
                            <Button
                                className="dialog-accept-button"
                                onClick={() => {
                                    options.acceptCallback && options.acceptCallback();
                                    unmount();
                                    resolve(true);
                                }}
                            >
                                {options.okButtonLabel || "Ok"}
                            </Button>
                        )

                    }

                </DialogActions>

            </BeautifulDialog>
        );
        let unmount = renderReactDialogFromJSX(dialog);
    });
}

export class ShowConfirmationWithCheckboxDialog extends Component {
    state = {
        isChecked: false
    }

    render() {
        const { title, message, cancelCallback, cancelButtonLabel, acceptCallback, okButtonLabel, checkboxMessage } = this.props;
        const { isChecked } = this.state;
        return (
            <BeautifulDialog
                closeDialog={this.props.closeDialog}
            >
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>{message}</DialogContent>
                <DialogActions>
                    <BlueOutlinedButton
                        style={{ minWidth: "120px" }}
                        onClick={() => {
                            cancelCallback && cancelCallback();
                            this.props.closeDialog();
                        }}
                    >
                        {cancelButtonLabel || "Cancel"}
                    </BlueOutlinedButton>
                    <BlueButton
                        style={{ minWidth: "150px" }}
                        onClick={() => {
                            acceptCallback && acceptCallback(isChecked);
                            this.props.closeDialog();
                        }}
                    >
                        {okButtonLabel || "Ok"}
                    </BlueButton>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}

export class ShowInputConfirmationDialog extends Component {
    constructor(props) {
        super(props);
        this.state = { value: "" };
    }

    componentDidMount() {
        const { input } = this.props;
        this.setState({ value: input.value || "" });
    }

    handleChange = evt => {
        this.setState({ value: evt.target.value });
    }

    render() {
        const { input = {}, title, cancelCallback, acceptCallback, cancelButtonLabel, okButtonLabel } = this.props;
        const { value } = this.state;

        return (
            <BeautifulDialog
                onBackdropClick={this.props.closeDialog}
                closeDialog={this.props.closeDialog}
            >
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <TextField
                        id={input.id}
                        autoFocus={true}
                        placeholder={input.placeholder}
                        value={value}
                        fullWidth={true}
                        type={input.type}
                        inputProps={input.inputProps}
                        onChange={this.handleChange}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            cancelCallback && cancelCallback();
                            this.props.closeDialog();
                        }}
                    >
                        {cancelButtonLabel || "Cancel"}
                    </Button>
                    <Button
                        onClick={() => {
                            acceptCallback && acceptCallback(value);
                            this.props.closeDialog();
                        }}
                    >
                        {okButtonLabel || "Ok"}
                    </Button>
                </DialogActions>
            </BeautifulDialog>);
    }
}

export function ShowErrorDialog(options) {
    return new Promise(resolve => {
        let dialog = (
            <BeautifulDialog classes={{ paper: "error-dialog" }} closeDialog={() => {
                if (options.acceptOnClose) {
                    options.acceptCallback && options.acceptCallback();
                }
                unmount();
            }}>
                <DialogTitle>{options.error || options.title}</DialogTitle>
                <DialogContent>{
                    (options.message instanceof Array)
                        ? options.message.map(m => <p>{m}</p>)
                        : options.message
                }</DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            options.acceptCallback && options.acceptCallback();
                            unmount();
                            resolve();
                        }}
                    >
                        Ok
                    </Button>
                </DialogActions>
            </BeautifulDialog>
        );

        let unmount = renderReactDialogFromJSX(dialog);
    });
}

export class ShowRefreshTimerDialog extends Component {
    state = {
        time: rand(5, 45)
    };

    componentDidMount = () => {
        setInterval(() => {
            this.setState(prevState => {
                return { time: prevState.time - 1 };
            }, () => {
                if (this.state.time <= 0) {
                    this.handleClose();
                }
            });
        }, 1000);
    }

    handleClose() {
        window.location.reload();
        this.props.closeDialog();
    }

    showMessage() {
        let { time } = this.state;
        return (<Fragment>This browser tab is running an old version of the application and must
            be refreshed. Your work will be saved.
            Refreshing in <span id="auto-refresh-timer">{time}</span> seconds.</Fragment>);
    }

    render() {
        return (
            <BeautifulDialog closeDialog={this.handleClose} onBackdropClick={this.handleClose}>
                <DialogTitle>Refresh Required</DialogTitle>
                <DialogContent>{this.showMessage()}</DialogContent>
                <DialogActions>
                    <Button
                        onClick={this.handleClose}
                    >
                        Refresh Now
                    </Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}

export class ShowDropdownConfirmationDialog extends Component {
    state = {
        choice: null
    };

    componentDidMount = () => {
        const { choices } = this.props;
        this.setState({
            choice: choices[0].value
        });
    };

    handleConfirm = choice => {
        const { onConfirm } = this.props;
        onConfirm && onConfirm(choice);
        this.props.closeDialog();
    };

    handleSelect = choice => {
        this.setState({
            choice
        });
    };

    renderDropdown = () => {
        const { choices } = this.props;

        return (
            <DropDown
                variant="text"
                handleSelect={this.handleSelect}
                items={choices}
                dropdownId={uuid()}
                selectedIndex={0}
                type="transparent"
            />
        );
    }

    render() {
        const { title, prompt, message, cancelButtonLabel, confirmButtonLabel } = this.props;
        const { choice } = this.state;
        return (
            <BeautifulDialog
                className="dialog-toggle-confirmation"
                closeDialog={this.props.closeDialog}
            >
                <DialogTitle>{prompt || title}</DialogTitle>
                <DialogContent>
                    {message}
                    <div style={{ textAlign: "center", marginTop: "24px" }}>
                        {this.renderDropdown()}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={this.props.closeDialog}
                    >
                        {cancelButtonLabel || "Cancel"}
                    </Button>
                    <Button
                        onClick={() => this.handleConfirm(choice)}
                    >
                        {confirmButtonLabel || "Ok"}
                    </Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}

export class MandatoryUpdate extends Component {
    render() {
        const { message } = this.props;
        return (
            <BeautifulDialog>
                <DialogTitle>Refresh Required</DialogTitle>
                <DialogContent>
                    {message}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => window.location.reload()}
                    >
                        Refresh
                    </Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
